import React, { FC, useRef } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppFieldBox } from 'components/appComponents';
import { DateBox, Validator } from 'devextreme-react';

type DateTaskProps = {
  value: string | Date | undefined;
  readOnly: boolean;
  onChange: (e: string | Date) => void;
  taskIsArch: boolean;
};

const DateTask: FC<DateTaskProps> = ({ value, readOnly, taskIsArch, onChange }) => {
  const TODAY = new Date();
  const ONE_DAY_MS = 86400330;

  const maxDate = new Date(Date.now() + 3600 * 1000 * 24 * 6);
  const minDate = new Date(Date.now() - 3600 * 1000 * 24 * 6);

  const startDate = useRef<DateBox>(null);

  const getDisabledDates = (args: any): boolean => {
    if (taskIsArch) return false;

    const weekTime = ONE_DAY_MS * 6;
    const getDate = args.date.getTime();

    return getDate <= TODAY.getTime() - ONE_DAY_MS || getDate >= TODAY.getTime() + weekTime;
  };

  return (
    <AppFieldBox label="Дата" labelTop>
      <DateBox
        stylingMode="underlined"
        readOnly={readOnly}
        type="date"
        //@ts-ignore
        onValueChange={onChange}
        useMaskBehavior
        dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
        value={value}
        //disabledDates={getDisabledDates}
        ref={startDate}
        onFocusIn={() => setTimeout(() => startDate.current?.instance.open(), 100)}
        min={taskIsArch ? undefined : minDate}
        max={taskIsArch ? undefined : maxDate}
      >
        <Validator>
          <RequiredRule message="Заполните поле дата" />
        </Validator>
      </DateBox>
    </AppFieldBox>
  );
};

export default DateTask;
